export default __webpack_public_path__ + "static/media/illustration-algocare-m@3x.35573ce8.webp";